import Divider from "@material-ui/core/Divider";

export default function MenuDivider() {
  return <Divider style={{ margin: "8px 0" }} />;
}
